// extracted by mini-css-extract-plugin
module.exports = {"item":"station_item__-P774","strapline":"station_strapline__3oQo9","heading":"station_heading__2rbmy"};